import React from 'react';
import { TableFieldApplications } from '@innovationnorway/kunde-raskavklaring-visning';
import { useOneWayIn } from 'src/features/one-way-in';
import { useParams } from 'react-router-dom';
import { PageParams } from 'src/features/one-way-in/opportunity-details/types/PageParams';
import { useTranslation } from 'react-i18next';
import '../../../../styles/CompanyInformationDetails.scss';

const CompanyInformationApplicationsTab = () => {
  const { formId } = useParams<PageParams>();
  const { oneWayInGroupedFormApplications } = useOneWayIn(formId);
  const { t: tSiva } = useTranslation('siva');

  const applications = oneWayInGroupedFormApplications.data?.felter ?? [];

  return (
    <>
      <TableFieldApplications navn={tSiva('companyTabs.applications.table.title')} felter={applications} />
    </>
  );
};

export default CompanyInformationApplicationsTab;
